import { Box, Typography } from "@mui/material";

import { EventDivisionItem } from "./EventDivisionItem";
import { T } from "../../util/t";
import { PageSection } from "../page/PageSection";
import { gql, useQuery } from "@apollo/client";
import { Event } from "graphql/generated/types";
import { GetEventMediaQuery, GetEventMediaQueryVariables } from "./EventDivisionList.types";
import { MediaFragment } from "graphql/media";

export const GET_EVENT_MEDIA = gql`
  query getEventMedia($id: ID!) {
    event(id: $id) {
      id
      media {
        ...Media
        heat {
          id
          eventDivision {
            id
          }
        }
      }
    }
  }
  ${MediaFragment}
`;

interface Props {
    event: Event;
}

export const EventDivisionList: React.FC<Props> = ({ event }) => {
    const isViewable = ["scheduled", "drawn", "upcoming", "cancelled"].indexOf(event.status) === -1;
    const { data } = useQuery<GetEventMediaQuery, GetEventMediaQueryVariables>(GET_EVENT_MEDIA, { variables: { id: event.id } });

    return (
        <>
            <PageSection />
            <Box component="section" paddingX={0}>
                <Typography variant="h5" component="h2"><T>Divisions</T></Typography>
                <Box component="ul" margin={0} padding={0} paddingBottom={9}>
                    {event.eventDivisions.filter(ed => !isViewable ? (ed.eventDivisions?.length || 0) === 0 : !ed.eventDivisionId).map(ed =>
                        <EventDivisionItem
                            key={ed.id}
                            shouldLink={isViewable}
                            eventDivision={ed}
                            event={event}
                            media={data?.event?.media as Event["media"]}
                        />
                    )}
                </Box>
            </Box>
        </>
    );
};
